<template>
  <CustomStylesApplier />
  <div class="_display:flex _flex-direction:column _height:100vh">
    <ILayout class="_background:white">
      <ILayoutHeader>
        <Head>
          <title>{{ metaState.title }}</title>
          <meta name="description" :content="metaState.description" head-key="description" />
          <meta name="keywords" :content="metaState.keywords" head-key="keywords" />
          <meta property="og:title" :content="metaState.og_title" head-key="og:title" />
          <meta
            property="og:description"
            :content="metaState.og_description"
            head-key="og:description" />
          <meta property="og:image" :content="metaState.ogImage" head-key="og:image" />
          <meta property="og:type" :content="metaState.og_type" head-key="og:type" />
          <meta property="og:url" :content="metaState.og_url" head-key="og:url" />
          <meta name="twitter:card" :content="metaState.twitter_card" head-key="twitter:card" />
          <meta name="twitter:site" :content="metaState.twitter_site" head-key="twitter:site" />
          <meta
            name="twitter:creator"
            :content="metaState.twitter_creator"
            head-key="twitter:creator" />
          <link v-if="metaState.canonical_link" rel="canonical" :href="metaState.canonical_link" />
          <meta
            v-if="metaState.author"
            name="author"
            :content="metaState.author"
            head-key="author" />
        </Head>
      </ILayoutHeader>
      <ILayoutContent class="header-bg">
        <div class="_margin-top:5">
          <NavBar />
          <main>
            <div class="_margin-y:0">
              <slot />
            </div>
          </main>
        </div>
      </ILayoutContent>
      <ILayoutFooter>
        <Footer />
      </ILayoutFooter>
    </ILayout>
  </div>
</template>

<script setup>
  import { Head } from '@inertiajs/vue3'
  import CustomStylesApplier from '@/Components/CustomStylesApplier.vue'
  import NavBar from '@/Components/Landing/NavBar.vue'
  import Footer from '@/Components/Landing/Footer.vue'
  import { useMeta } from '@/Composables/useMeta'

  const { metaState } = useMeta()
</script>
